import {Component} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {InstruccionescodigoComponent} from 'src/app/modal/instruccionescodigo/instruccionescodigo.component';
import {InstruccionesfotoComponent} from 'src/app/modal/instruccionesfoto/instruccionesfoto.component';
import {LugarentregaComponent} from 'src/app/modal/lugarentrega/lugarentrega.component';
import {PickupService} from 'src/app/services/pickup.service';
import {QueueService} from 'src/app/services/queue.service';
import {UtilitiesService} from 'src/app/services/utilities.service';
import {StatusLogService} from "../../../services/status-log.service";

@Component({
  selector: 'app-opciones-entrega',
  templateUrl: './opciones-entrega.component.html',
  styleUrls: ['./opciones-entrega.component.scss']
})
export class OpcionesEntregaComponent {

  loader: boolean = true;
  lugar_entrega: string = '';
  comentario: string = '';
  screen_height: number = window.screen.height;
  screen_width: number = window.screen.width;

  constructor(
    public pickupService: PickupService,
    public queueService: QueueService,
    private router: Router,
    public dialog: MatDialog,
    public utilityService: UtilitiesService,
    private statusService: StatusLogService
  ) {
  }

  ngOnInit(): void {


    console.log(this.pickupService.usuario);
  }

  // showLoader(){
  //   if(this.pickupService.cola_firma.length){
  //     this.loader = true;
  //   }else{
  //     this.loader = false;
  //   }

  //   setTimeout(() => {
  //     if(this.loader) this.showLoader();
  //   }, 100);
  // }

  async resizeImage(image: any) {
    this.pickupService.pedidoActivo.loader_entrega = 'entregando';

    // this.pickupService.pedidoActivo.lugar_entrega = this.queueService.lugar_entrega;


    // this.pickupService.entregarPedidoFirma(this.pickupService.pedidoActivo);

    // this.showLoader();

    let img = new Image();
    img.src = image;

    img.onload = () => {

      let canvas = document.createElement('canvas');
      let canvasCopy = document.createElement("canvas");
      let copyContext = canvasCopy.getContext("2d");
      let canvasContext = canvas.getContext('2d');

      let MAX_WIDTH = 400;
      let MAX_HEIGHT = 400;

      let ratio = 1;
      if (img.width > MAX_WIDTH)
        ratio = MAX_WIDTH / img.width;
      else if (img.height > MAX_HEIGHT)
        ratio = MAX_HEIGHT / img.height;

      canvasCopy.width = img.width;
      canvasCopy.height = img.height;
      copyContext?.drawImage(img, 0, 0);

      this.pickupService.pedidoActivo.imagen_firma = canvasCopy.toDataURL();

      console.log(this.pickupService.pedidoActivo.imagen_firma);

      // this.pickupService.entregarPedidoFoto(this.pickupService.pedidoActivo);
      this.queueService.agregarColaLoop(this.pickupService.pedidoActivo);
    };

  }

  async presentModalInstruccionesCodigo() {


    this.statusService.changePedidoStatus(this.pickupService.pedidoActivo, 5);
    const modalLugar = this.dialog.open(LugarentregaComponent, {
      height: (this.utilityService.modal_height) + 'px',
      width: (this.utilityService.modal_width) + 'px',
      maxHeight: (this.screen_height) + 'px',
      maxWidth: (this.screen_width) + 'px',

    });


    modalLugar.afterClosed().subscribe((data: any) => {


      if (data) {
        this.pickupService.pedidoActivo.lugar_entrega = data;

        const modal = this.dialog.open(InstruccionescodigoComponent, {
          height: (this.utilityService.modal_height) + 'px',
          width: (this.utilityService.modal_width) + 'px',
          maxHeight: (this.screen_height) + 'px',
          maxWidth: (this.screen_width) + 'px',
        });

        modal.afterClosed().subscribe((data: { success: boolean }) => {
          const {success} = data;

          if (success) {
            this.pickupService.pedidoActivo.tipo_entrega = 'codigo';
            this.pickupService.pedidoActivo.loader_entrega = 'entregando';
            //this.pickupService.pedidoActivo.lugar_entrega = this.queueService.lugar_entrega;
            //console.log('lugar :'+ this.queueService.lugar_entrega);

            console.log("====>");
            console.log(this.pickupService.pedidoActivo);
            console.log("====X");


            if (this.pickupService.usuario.validacion_entrega == 'codigo_foto') {

              const modal = this.dialog.open(InstruccionesfotoComponent, {
                height: (this.utilityService.modal_height) + 'px',
                width: (this.utilityService.modal_width) + 'px',
                maxHeight: (this.screen_height) + 'px',
                maxWidth: (this.screen_width) + 'px',
              });

              modal.afterClosed().subscribe(result => {
                console.log('The dialog was closed', result);
                if (result?.photo) {
                  // this.presentModalInfoRetira();
                  this.resizeImage(result.photo);

                  this.router.navigate(['/comentarios'], {queryParams: {tipo_entrada: 'entrega'}});
                }
              });


            } else {

              this.queueService.agregarColaLoop(this.pickupService.pedidoActivo);
              this.router.navigate(['/comentarios'], {queryParams: {tipo_entrada: 'entrega'}});

            }


          }
        });
      }


    });


  }

  async presentModalInstruccionesFoto() {

    this.statusService.changePedidoStatus(this.pickupService.pedidoActivo, 5);
    this.pickupService.pedidoActivo.tipo_entrega = 'foto';
    console.log('modal fotos');
    const modalLugar = this.dialog.open(LugarentregaComponent, {
      height: (this.utilityService.modal_height) + 'px',
      width: (this.utilityService.modal_width) + 'px',
      maxHeight: (this.screen_height) + 'px',
      maxWidth: (this.screen_width) + 'px',

    });


    modalLugar.afterClosed().subscribe((data: any) => {
      console.log('modal lugar');
      if (data) {
        console.log('lugar entrega : ');
        console.log(data);
        this.pickupService.pedidoActivo.lugar_entrega = data;

        const modal = this.dialog.open(InstruccionesfotoComponent, {
          height: (this.utilityService.modal_height) + 'px',
          width: (this.utilityService.modal_width) + 'px',
          maxHeight: (this.screen_height) + 'px',
          maxWidth: (this.screen_width) + 'px',
        });

        modal.afterClosed().subscribe(result => {
          console.log('The dialog was closed', result);
          if (result?.photo) {
            // this.presentModalInfoRetira();
            this.resizeImage(result.photo);

            this.router.navigate(['/comentarios'], {queryParams: {tipo_entrada: 'entrega'}});
          }
        });
      }

    });
  }


  volver() {
    this.router.navigate(['/opciones']);
  }

}
